var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.6L14.6 7L17 9.4L6.4 20H4V17.6Z",
    fill: "#161F29",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 6L17.6 4L20 6.4L18 8.4L15.6 6Z",
    fill: "#161F29",
    fillOpacity: 0.6
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pencil.532049043c6c5db914dd287a1171ab26.svg";